import { apiGet } from "../baseApi";
import { setCampusData } from "service/mapper";

export const getById = async (id, cancelToken = null) => {
  try {
    const response = await apiGet("_campus", {}, id, { cancelToken });
    return { ...response, data: setCampusData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
